/**
 * Genis ekranda dashboard'un sol/sag dis kenarlarindaki dekoratif marka
 * bannerlari (yesil boga / kirmizi ayi) - kullanici istegi.
 *
 * KESINLIKLE fonksiyonel DEGIL: `position: fixed`, `pointer-events: none`,
 * `z-index: -1` (bkz. theme.css .market-side-banners) - dashboard'un
 * ONUNE GECMEZ, tiklama/etkilesim ALMAZ. Sinyal hesaplama/API/backend
 * mantigina HICBIR SEKILDE dokunmaz, saf gorsel katmandir.
 *
 * Gorsel dosya yollarini degistirmek icin sadece asagidaki iki sabiti
 * guncelle (public/banners/ altinda saklanir, Vite bunlari oldugu gibi
 * sunar).
 */

const BULL_BANNER_URL = "/banners/bull.png?v=3";
const BEAR_BANNER_URL = "/banners/bear.png?v=3";

export function MarketSideBanners() {
  return (
    <div className="market-side-banners" aria-hidden="true">
      <img className="side-banner bull-banner" src={BULL_BANNER_URL} alt="" />
      <img className="side-banner bear-banner" src={BEAR_BANNER_URL} alt="" />
    </div>
  );
}
